/**
 * @namespace Salla.config
 *
 * @property {any} properties_
 */
export default class Config {

  default_properties: object|any;
  properties_: object|any;

  constructor(properties = {}, default_properties = {}) {
    this.default_properties = default_properties;
    this.properties_ = { ...this.default_properties, ...properties };
  }

  merge(config:object) {
    this.properties_ = {...this.properties_, ...config};

    this.properties_.store = { ...this.default_properties?.store||{}, ...this.properties_.store };	
    return this;
  }

  set(key:string, value:any) {
    if (key.includes(".")) {
      Salla.helpers.setNested(this.properties_, key, value);
      return this;
    }
    this.properties_[key] = value;
    return this;
  }

  /**
   * @param {string|undefined} isoCode
   * @return {Currency}
   */
  currency(isoCode:string|undefined = undefined){
    isoCode = isoCode || this.get('user.currency_code');
    return this.get('currencies.' + isoCode) || Object.values(this.get('currencies'))[0];
  }


  /**
   * @param {string} key
   * @param {null|any} default_
   * @return {any}
   */
  get(key:string, default_ = null) {
    if (key.includes(".")) {
      return Salla.helpers.getNested(this.properties_, key, default_);
    }
    return this.properties_.hasOwnProperty(key) ? this.properties_[key] || default_ : default_ || undefined;
  }

  all() {
    return this.properties_;
  }

  isDebug() {
    return this.get('debug') || Salla.storage.get('debug');
  }
}
